import React from 'react';

import Lozenge from '@atlaskit/lozenge';

const EvalLozenge = () => (
  <span className="lozenge eval-lozenge">
    <Lozenge appearance="new">Eval</Lozenge>
  </span>
);

export default EvalLozenge;
